import * as React from "react";
import AlignBottomCenterIcon from "./icons/align-bottom-center.svg";
import AlignBottomLeftIcon from "./icons/align-bottom-left.svg";
import AlignBottomRightIcon from "./icons/align-bottom-right.svg";
import AlignBottomIcon from "./icons/align-bottom.svg";
import AlignCenterCenterIcon from "./icons/align-center-center.svg";
import AlignCenterIconIcon from "./icons/align-center-icon.svg";
import AlignCenterLeftIcon from "./icons/align-center-left.svg";
import AlignCenterRightIcon from "./icons/align-center-right.svg";
import AlignCenterIcon from "./icons/align-center.svg";
import AlignJustifyIcon from "./icons/align-justify.svg";
import AlignLeftIconIcon from "./icons/align-left-icon.svg";
import AlignLeftIcon from "./icons/align-left.svg";
import AlignMiddleIcon from "./icons/align-middle.svg";
import AlignRightIconIcon from "./icons/align-right-icon.svg";
import AlignRightIcon from "./icons/align-right.svg";
import AlignTopCenterIcon from "./icons/align-top-center.svg";
import AlignTopLeftIcon from "./icons/align-top-left.svg";
import AlignTopRightIcon from "./icons/align-top-right.svg";
import AlignTopIcon from "./icons/align-top.svg";
import BackArrowIcon from "./icons/back-arrow.svg";
import BalanceHorizontalIcon from "./icons/balance-horizontal.svg";
import BalanceVerticalIcon from "./icons/balance-vertical.svg";
import BorderColorIcon from "./icons/border-color.svg";
import BorderHandleDownIcon from "./icons/border-handle-down.svg";
import BorderHandleLeftIcon from "./icons/border-handle-left.svg";
import BorderHandleRightIcon from "./icons/border-handle-right.svg";
import BorderHandleUpIcon from "./icons/border-handle-up.svg";
import BorderHandleIcon from "./icons/border-handle.svg";
import BordersAllIcon from "./icons/borders-all.svg";
import BordersHorizontalIcon from "./icons/borders-horizontal.svg";
import BordersNoneIcon from "./icons/borders-none.svg";
import BordersTableIcon from "./icons/borders-table.svg";
import BordersVerticalIcon from "./icons/borders-vertical.svg";
import BulletPointIcon from "./icons/bullet-point.svg";
import BulletsIcon from "./icons/bullets.svg";
import CloseIcon from "./icons/close.svg";
import FontSizeIncreaseIcon from "./icons/menu/font-increment.svg";
import FontSizeDecreaseIcon from "./icons/menu/font-decrement.svg";
import ColorFillIcon from "./icons/color-fill.svg";
import ColorLineIcon from "./icons/color-line.svg";
import ColumnHandleIcon from "./icons/column-handle.svg";
import DeleteIcon from "./icons/delete.svg";
import CropIcon from "./icons/crop.svg";
import RestoreIcon from "./icons/restore.svg";
import ExportIcon from "./icons/export.svg";
import FeedbackIcon from "./icons/feedback.svg";
import FixStylesIcon from "./icons/fix-styles.svg";
import FontColorIcon from "./icons/font-color.svg";
import FontIcon from "./icons/font.svg";
import HandleHorizontalSelectedIcon from "./icons/handle-horizontal-selected.png";
import HandleHorizontalIcon from "./icons/handle-horizontal.png";
import HandleVerticalSelectedIcon from "./icons/handle-vertical-selected.png";
import HandleVerticalIcon from "./icons/handle-vertical.png";
import HamburgerIcon from "./icons/hamburger.svg";
import IconEnclosedFilledIcon from "./icons/icon-enclosed-filled.svg";
import IconEnclosedIcon from "./icons/icon-enclosed.svg";
import IconIcon from "./icons/icon.svg";
import IconNotEnclosedIcon from "./icons/icon-not-enclosed.svg";
import IconLargeIcon from "./icons/icon-large.svg";
import ImportIcon from "./icons/import.svg";
import InsertBorderFilledHorizontalIcon from "./icons/insert-border h.svg";
import InsertBorderFilledIcon from "./icons/insert-border-filled.svg";
import InsertBorderHorizontalIcon from "./icons/insert-border-horizontal.svg";
import InsertBorderInactiveIcon from "./icons/insert-border-inactive.svg";
import InsertBorderVerticalIcon from "./icons/insert-border-vertical.svg";
import InsertBorderIcon from "./icons/insert-border.svg";
import InsertColumnFilledIcon from "./icons/insert-column-filled.svg";
import InsertColumnIcon from "./icons/insert-column.svg";
import InsertImageIcon from "./icons/insert-image.svg";
import InsertRowFilledIcon from "./icons/insert-row-n.svg";
import InsertRowIcon from "./icons/insert-row.svg";
import InsertShapeIcon from "./icons/insert-shape.svg";
import InsertSpacerFilledIcon from "./icons/insert-spacer-filled.svg";
import InsertSpacerHorizontalIcon from "./icons/insert-spacer-horizontal.svg";
import InsertSpacerVerticalIcon from "./icons/insert-spacer-vertical.svg";
import InsertSpacerFilledHorizontalIcon from "./icons/insert-spacer h.svg";
import InsertSpacerIcon from "./icons/insert-spacer.svg";
import InvertTextColorIcon from "./icons/invert-text-color.svg";
import LineThicknessIcon from "./icons/line-thickness.svg";
import LineTypeDashedIcon from "./icons/line-type-dashed.svg";
import LineTypeDottedIcon from "./icons/line-type-dotted.svg";
import LineTypeSolidIcon from "./icons/line-type-solid.svg";
import LineTypeSolidMediumIcon from "./icons/line-type-solid-medium.svg";
import LineTypeSolidHeavyIcon from "./icons/line-type-solid-heavy.svg";
import LineTypesIcon from "./icons/line-types.svg";
import Logo16Icon from "./icons/logo-16x16.svg";
import Logo32Icon from "./icons/logo-32x32.svg";
import Logo64Icon from "./icons/logo-64x64.svg";
import LogoIcon from "./icons/logo.svg";
import LogoHoveredIcon from "./icons/logo-hovered.svg";
import MenuTabOpenIcon from "./icons/menu-tab-open.svg";
import MergeIcon from "./icons/merge.svg";
import MoveHandleIcon from "./icons/move-handle.svg";
import NumbersIcon from "./icons/numbers.svg";
import NoneIcon from "./icons/none.svg";
import OpenIcon from "./icons/open.svg";
import OpenBlueIcon from "./icons/open-blue.svg";
import ResizeHandleBottomIcon from "./icons/resize-handle-bottom.svg";
import ResizeHandleLeftIcon from "./icons/resize-handle-left.svg";
import ResizeHandleRightIcon from "./icons/resize-handle-right.svg";
import ResizeHandleTopIcon from "./icons/resize-handle-top.svg";
import ResizeHandleIcon from "./icons/resize-handle.svg";
import RightClickIcon from "./icons/right-click.svg";
import ShapeArrowCommonIcon from "./icons/shapes/shape-arrow-common.svg";
import ShapeArrowFullIcon from "./icons/shapes/shape-arrow-full.svg";
import ShapeArrowThinIcon from "./icons/shapes/shape-arrow-thin.svg";
import ShapeCircleIcon from "./icons/shapes/shape-circle.svg";
import ShapeRectangleIcon from "./icons/shapes/shape-rectangle.svg";
import ShapeRoundedRectangleIcon from "./icons/shapes/shape-rounded-rectangle.svg";
import ShapeRoundedThinRectangleIcon from "./icons/shapes/shape-rounded-thin-rectangle.svg";
import ShapeArrowWithoutTailIcon from "./icons/shapes/shape-arrow-without-tail.svg";
import ShapeArrowCurvedIcon from "./icons/shapes/shape-arrow-curved.svg";
import ShapeOvalIcon from "./icons/shapes/shape-oval.svg";
import ShapeQuarterIcon from "./icons/shapes/shape-quarter.svg";
import ShapeTrapeze1Icon from "./icons/shapes/shape-trapeze-1.svg";
import ShapeTrapeze2Icon from "./icons/shapes/shape-trapeze-2.svg";
import ShapeTrapeze3Icon from "./icons/shapes/shape-trapeze-3.svg";
import ShapeTriangleLongIcon from "./icons/shapes/shape-triangle-long.svg";
import ShapeTriangleIcon from "./icons/shapes/shape-triangle.svg";
import SizeLIcon from "./icons/size-L.svg";
import SizeMIcon from "./icons/size-M.svg";
import SizeSIcon from "./icons/size-S.svg";
import SizeXLIcon from "./icons/size-XL.svg";
import SpacerWidth1Icon from "./icons/spacer-width-1.svg";
import SpacerWidth2Icon from "./icons/spacer-width-2.svg";
import SpacerWidth3Icon from "./icons/spacer-width-3.svg";
import SpacerWidth4Icon from "./icons/spacer-width-4.svg";
import SpacerWidth5Icon from "./icons/spacer-width-5.svg";
import SplitAllIcon from "./icons/split-all.svg";
import SplitIcon from "./icons/split.svg";
import NewStyleSheetIcon from "./icons/style-sheet.svg";
import StylesheetBordersIcon from "./icons/stylesheet-borders.svg";
import StylesheetColorsIcon from "./icons/stylesheet-colors.svg";
import StylesheetDuplicateIcon from "./icons/stylesheet-duplicate.svg";
import StylesheetExportIcon from "./icons/stylesheet-export.svg";
import StylesheetFontsIcon from "./icons/stylesheet-fonts.svg";
import StylesheetRenameIcon from "./icons/stylesheet-rename.svg";
import StylesheetResetIcon from "./icons/stylesheet-reset.svg";
import StylesheetSettingsIcon from "./icons/stylesheet-settings.svg";
import StylesheetSpacersIcon from "./icons/stylesheet-spacers.svg";
import StylesheetSpacingIcon from "./icons/stylesheet-spacing.svg";
import StylesheetIcon from "./icons/stylesheet.svg";
import SwapIcon from "./icons/swap.svg";
import TemplateIcon from "./icons/template.svg";
import TemplatesIcon from "./icons/templates.svg";
import TutorialsIcon from "./icons/tutorials.svg";
import HandleSlotIcon from "./icons/handle slot.svg";
import HandleSlotRolloverIcon from "./icons/handle slot rollover grey.svg";
import ArrangeMenuIcon from "./icons/menu/arrange.svg";
import BorderStyleMenuIcon from "./icons/menu/border-style.svg";
import ColorFillMenuIcon from "./icons/menu/color-fill-menu.svg";
import IconsMenuIcon from "./icons/menu/icon-menu.svg";
import ImageMenuIcon from "./icons/menu/image.svg";
import InsertMenuIcon from "./icons/menu/insert-menu.svg";
import ShapesMenuIcon from "./icons/menu/shape.svg";
import SpacerWidthMenuIcon from "./icons/menu/spacer-width.svg";
import TextMenuIcon from "./icons/menu/text.svg";
import BakeMenuIcon from "./icons/stackmenu/bake-default.svg";
import BakeHoverMenuIcon from "./icons/stackmenu/bake-hover.svg";
import OverhangBottomIcon from "./icons/shapes/positioning/position1.svg";
import OverhangLeftIcon from "./icons/shapes/positioning/position2.svg";
import FlushBottomIcon from "./icons/shapes/positioning/position3.svg";
import FlushLeftIcon from "./icons/shapes/positioning/position4.svg";
import SmallShapeIcon from "./icons/shapes/positioning/position5.svg";
import MediumShapeIcon from "./icons/shapes/positioning/position6.svg";
import Medium5ShapeIcon from "./icons/shapes/positioning/medium5.svg";
import FullWidthIcon from "./icons/shapes/positioning/position7.svg";
import FlipHorizontalIcon from "./icons/shapes/rotation/flip-horizontal.svg";
import FlipVerticalIcon from "./icons/shapes/rotation/flip-vertical.svg";
import MarginsIcon from "./icons/menu/margins.svg";
import PromptIcon from "./icons/stackmenu/prompt.svg";
import StructureMenuIcon from "./icons/menu/structure-menu.svg";
import CopyIcon from "./icons/menu/copy.svg";
import PasteIcon from "./icons/menu/paste.svg";
import PyramidIcon from "./icons/shapes/shape-group-pyramid.svg";

export { ResizeHandleBottomIcon, ResizeHandleLeftIcon, ResizeHandleRightIcon, ResizeHandleTopIcon };

// eslint-disable-next-line react/prop-types
export const AlignBottomCenter = ({ style }) => {
  return <img src={AlignBottomCenterIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignBottomLeft = ({ style }) => {
  return <img src={AlignBottomLeftIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignBottomRight = ({ style }) => {
  return <img src={AlignBottomRightIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignBottom = ({ style }) => {
  return <img src={AlignBottomIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignCenterCenter = ({ style }) => {
  return <img src={AlignCenterCenterIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignCenterLeft = ({ style }) => {
  return <img src={AlignCenterLeftIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignCenterRight = ({ style }) => {
  return <img src={AlignCenterRightIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignCenter = ({ style }) => {
  return <img src={AlignCenterIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignJustify = ({ style }) => {
  return <img src={AlignJustifyIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignLeft = ({ style }) => {
  return <img src={AlignLeftIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignMiddle = ({ style }) => {
  return <img src={AlignMiddleIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignRight = ({ style }) => {
  return <img src={AlignRightIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignTopCenter = ({ style }) => {
  return <img src={AlignTopCenterIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignTopLeft = ({ style }) => {
  return <img src={AlignTopLeftIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignTopRight = ({ style }) => {
  return <img src={AlignTopRightIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const AlignTop = ({ style }) => {
  return <img src={AlignTopIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BackArrow = ({ style }) => {
  return <img src={BackArrowIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BalanceHorizontal = ({ style }) => {
  return <img src={BalanceHorizontalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BalanceVertical = ({ style }) => {
  return <img src={BalanceVerticalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BorderColor = ({ style }) => {
  return <img src={BorderColorIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BorderHandleDown = ({ style }) => {
  return <img src={BorderHandleDownIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BorderHandleLeft = ({ style }) => {
  return <img src={BorderHandleLeftIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BorderHandleRight = ({ style }) => {
  return <img src={BorderHandleRightIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BorderHandleUp = ({ style }) => {
  return <img src={BorderHandleUpIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BorderHandle = ({ style }) => {
  return <img src={BorderHandleIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BordersAll = ({ style }) => {
  return <img src={BordersAllIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BordersHorizontal = ({ style }) => {
  return <img src={BordersHorizontalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BordersNone = ({ style }) => {
  return <img src={BordersNoneIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BordersTable = ({ style }) => {
  return <img src={BordersTableIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BordersVertical = ({ style }) => {
  return <img src={BordersVerticalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BulletPoint = ({ style }) => {
  return <img src={BulletPointIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Bullets = ({ style }) => {
  return <img src={BulletsIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Close = ({ style }) => {
  return <img src={CloseIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const FontSizeIncrease = ({ style }) => {
  return <img src={FontSizeIncreaseIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const FontSizeDecrease = ({ style }) => {
  return <img src={FontSizeDecreaseIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ColorFill = ({ style }) => {
  return <img src={ColorFillIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ColorLine = ({ style }) => {
  return <img src={ColorLineIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ColumnHandle = ({ style }) => {
  return <img src={ColumnHandleIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Delete = ({ style }) => {
  return <img src={DeleteIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Crop = ({ style }) => {
  return <img src={CropIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Restore = ({ style }) => {
  return <img src={RestoreIcon} style={style} />;
};

// eslint-disable-next-line react/prop-types
export const Export = ({ style }) => {
  return <img src={ExportIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Feedback = ({ style }) => {
  return <img src={FeedbackIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const FixStyles = ({ style }) => {
  return <img src={FixStylesIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const FontColor = ({ style }) => {
  return <img src={FontColorIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Font = ({ style }) => {
  return <img src={FontIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const HandleHorizontalSelected = ({ style }) => {
  return <img src={HandleHorizontalSelectedIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const HandleHorizontal = ({ style }) => {
  return <img src={HandleHorizontalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const HandleVerticalSelected = ({ style }) => {
  return <img src={HandleVerticalSelectedIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const HandleVertical = ({ style }) => {
  return <img src={HandleVerticalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Hamburger = ({ style }) => {
  return <img src={HamburgerIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const IconAlignCenterIcon = ({ style }) => {
  return <img src={AlignCenterIconIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const IconAlignLeftIcon = ({ style }) => {
  return <img src={AlignLeftIconIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const IconAlignRightIcon = ({ style }) => {
  return <img src={AlignRightIconIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const IconEnclosedFilled = ({ style }) => {
  return <img src={IconEnclosedFilledIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const IconEnclosed = ({ style }) => {
  return <img src={IconEnclosedIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const IconNotEnclosed = ({ style }) => {
  return <img src={IconNotEnclosedIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Icon = ({ style }) => {
  return <img src={IconIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const IconLarge = ({ style }) => {
  return <img src={IconLargeIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Import = ({ style }) => {
  return <img src={ImportIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertBorderFilledHorizontal = ({ style }) => {
  return <img src={InsertBorderFilledHorizontalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertBorderFilled = ({ style }) => {
  return <img src={InsertBorderFilledIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertBorderHorizontal = ({ style }) => {
  return <img src={InsertBorderHorizontalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertBorderInactive = ({ style }) => {
  return <img src={InsertBorderInactiveIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertBorderVertical = ({ style }) => {
  return <img src={InsertBorderVerticalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertBorder = ({ style }) => {
  return <img src={InsertBorderIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertColumnFilled = ({ style }) => {
  return <img src={InsertColumnFilledIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertColumn = ({ style }) => {
  return <img src={InsertColumnIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertImage = ({ style }) => {
  return <img src={InsertImageIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertRowFilled = ({ style }) => {
  return <img src={InsertRowFilledIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertRow = ({ style }) => {
  return <img src={InsertRowIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertShape = ({ style }) => {
  return <img src={InsertShapeIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertSpacerFilled = ({ style }) => {
  return <img src={InsertSpacerFilledIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertSpacerHorizontal = ({ style }) => {
  return <img src={InsertSpacerHorizontalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertSpacerVertical = ({ style }) => {
  return <img src={InsertSpacerVerticalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertSpacerFilledHorizontal = ({ style }) => {
  return <img src={InsertSpacerFilledHorizontalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertSpacer = ({ style }) => {
  return <img src={InsertSpacerIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InvertTextColor = ({ style }) => {
  return <img src={InvertTextColorIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const LineThickness = ({ style }) => {
  return <img src={LineThicknessIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const LineTypeDashed = ({ style }) => {
  return <img src={LineTypeDashedIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const LineTypeDotted = ({ style }) => {
  return <img src={LineTypeDottedIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const LineTypeSolid = ({ style }) => {
  return <img src={LineTypeSolidIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const LineTypeSolidMedium = ({ style }) => {
  return <img src={LineTypeSolidMediumIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const LineTypeSolidHeavy = ({ style }) => {
  return <img src={LineTypeSolidHeavyIcon} style={style} />;
};

// eslint-disable-next-line react/prop-types
export const LineTypes = ({ style }) => {
  return <img src={LineTypesIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Logo16 = ({ style }) => {
  return <img src={Logo16Icon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Logo32 = ({ style }) => {
  return <img src={Logo32Icon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Logo64 = ({ style }) => {
  return <img src={Logo64Icon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Logo = ({ style }) => {
  return <img src={LogoIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const LogoHovered = ({ style }) => {
  return <img src={LogoHoveredIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Margins = ({ style }) => {
  return <img src={MarginsIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const MenuTabOpen = ({ style }) => {
  return <img src={MenuTabOpenIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Merge = ({ style }) => {
  return <img src={MergeIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const MoveHandle = ({ style }) => {
  return <img src={MoveHandleIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Numbers = ({ style }) => {
  return <img src={NumbersIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const None = ({ style }) => {
  return <img src={NoneIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Open = ({ style }) => {
  return <img src={OpenIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const OpenBlue = ({ style }) => {
  return <img src={OpenBlueIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ResizeHandleBottom = ({ style }) => {
  return <img src={ResizeHandleBottomIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ResizeHandleLeft = ({ style }) => {
  return <img src={ResizeHandleLeftIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ResizeHandleRight = ({ style }) => {
  return <img src={ResizeHandleRightIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ResizeHandleTop = ({ style }) => {
  return <img src={ResizeHandleTopIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ResizeHandle = ({ style }) => {
  return <img src={ResizeHandleIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const RightClick = ({ style }) => {
  return <img src={RightClickIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeArrowCommon = ({ style }) => {
  return <img src={ShapeArrowCommonIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeArrowFull = ({ style }) => {
  return <img src={ShapeArrowFullIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeArrowThin = ({ style }) => {
  return <img src={ShapeArrowThinIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeCircle = ({ style }) => {
  return <img src={ShapeCircleIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeRectangle = ({ style }) => {
  return <img src={ShapeRectangleIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeRoundedRectangle = ({ style }) => {
  return <img src={ShapeRoundedRectangleIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeRoundedThinRectangle = ({ style }) => {
  return <img src={ShapeRoundedThinRectangleIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeArrowWithoutTail = ({ style }) => {
  return <img src={ShapeArrowWithoutTailIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeArrowCurved = ({ style }) => {
  return <img src={ShapeArrowCurvedIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeOval = ({ style }) => {
  return <img src={ShapeOvalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeQuarter = ({ style }) => {
  return <img src={ShapeQuarterIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeTrapeze1 = ({ style }) => {
  return <img src={ShapeTrapeze1Icon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeTrapeze2 = ({ style }) => {
  return <img src={ShapeTrapeze2Icon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeTrapeze3 = ({ style }) => {
  return <img src={ShapeTrapeze3Icon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeTriangleLong = ({ style }) => {
  return <img src={ShapeTriangleLongIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapeTriangle = ({ style }) => {
  return <img src={ShapeTriangleIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const SizeL = ({ style }) => {
  return <img src={SizeLIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const SizeM = ({ style }) => {
  return <img src={SizeMIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const SizeS = ({ style }) => {
  return <img src={SizeSIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const SizeXL = ({ style }) => {
  return <img src={SizeXLIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const SpacerWidth1 = ({ style }) => {
  return <img src={SpacerWidth1Icon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const SpacerWidth2 = ({ style }) => {
  return <img src={SpacerWidth2Icon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const SpacerWidth3 = ({ style }) => {
  return <img src={SpacerWidth3Icon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const SpacerWidth4 = ({ style }) => {
  return <img src={SpacerWidth4Icon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const SpacerWidth5 = ({ style }) => {
  return <img src={SpacerWidth5Icon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const SplitAll = ({ style }) => {
  return <img src={SplitAllIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Split = ({ style }) => {
  return <img src={SplitIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const NewStyleSheet = ({ style }) => {
  return <img src={NewStyleSheetIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const StylesheetBorders = ({ style }) => {
  return <img src={StylesheetBordersIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const StylesheetColors = ({ style }) => {
  return <img src={StylesheetColorsIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const StylesheetDuplicate = ({ style }) => {
  return <img src={StylesheetDuplicateIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const StylesheetExport = ({ style }) => {
  return <img src={StylesheetExportIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const StylesheetFonts = ({ style }) => {
  return <img src={StylesheetFontsIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const StylesheetRename = ({ style }) => {
  return <img src={StylesheetRenameIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const StylesheetReset = ({ style }) => {
  return <img src={StylesheetResetIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const StylesheetSettings = ({ style }) => {
  return <img src={StylesheetSettingsIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const StylesheetSpacers = ({ style }) => {
  return <img src={StylesheetSpacersIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const StylesheetSpacing = ({ style }) => {
  return <img src={StylesheetSpacingIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Stylesheet = ({ style }) => {
  return <img src={StylesheetIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Swap = ({ style }) => {
  return <img src={SwapIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Template = ({ style }) => {
  return <img src={TemplateIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Templates = ({ style }) => {
  return <img src={TemplatesIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Tutorials = ({ style }) => {
  return <img src={TutorialsIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const HandleSlot = ({ style }) => {
  return <img src={HandleSlotIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const HandleSlotRollover = ({ style }) => {
  return <img src={HandleSlotRolloverIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ArrangeMenu = ({ style }) => {
  return <img src={ArrangeMenuIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BorderStyleMenu = ({ style }) => {
  return <img src={BorderStyleMenuIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ColorFillMenu = ({ style }) => {
  return <img src={ColorFillMenuIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const IconsMenu = ({ style }) => {
  return <img src={IconsMenuIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ImageMenu = ({ style }) => {
  return <img src={ImageMenuIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const InsertMenu = ({ style }) => {
  return <img src={InsertMenuIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const ShapesMenu = ({ style }) => {
  return <img src={ShapesMenuIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const SpacerWidthMenu = ({ style }) => {
  return <img src={SpacerWidthMenuIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const TextMenu = ({ style }) => {
  return <img src={TextMenuIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BakeMenu = ({ style }) => {
  return <img src={BakeMenuIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const BakeHoverMenu = ({ style }) => {
  return <img src={BakeHoverMenuIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const FullWidth = ({ style }) => {
  return <img src={FullWidthIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const MediumShape = ({ style }) => {
  return <img src={MediumShapeIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Medium5Shape = ({ style }) => {
  return <img src={Medium5ShapeIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const SmallShape = ({ style }) => {
  return <img src={SmallShapeIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const FlushLeft = ({ style }) => {
  return <img src={FlushLeftIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const FlushBottom = ({ style }) => {
  return <img src={FlushBottomIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const OverhangLeft = ({ style }) => {
  return <img src={OverhangLeftIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const OverhangBottom = ({ style }) => {
  return <img src={OverhangBottomIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const FlipHorizontal = ({ style }) => {
  return <img src={FlipHorizontalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const FlipVertical = ({ style }) => {
  return <img src={FlipVerticalIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Prompt = ({ style }) => {
  return <img src={PromptIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const StructureMenu = ({ style }) => {
  return <img src={StructureMenuIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Copy = ({ style }) => {
  return <img src={CopyIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Paste = ({ style }) => {
  return <img src={PasteIcon} style={style} />;
};
// eslint-disable-next-line react/prop-types
export const Pyramid = ({ style }) => {
  return <img src={PyramidIcon} style={style} />;
};
